import {
 Outlet, useLocation
} from 'react-router-dom'
import {
 useAuth
} from '../hooks/useAuth'
import {
 Navbar
} from './Navbar'
import {
 ErrorBoundary
} from './ErrorBoundary'

export function Layout(): JSX.Element {
  const { isLoading } = useAuth()
  const { pathname } = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="container mx-auto w-full px-4 py-8 flex-1">
        <ErrorBoundary boundary="page" resetKey={pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
      <footer className="py-6 text-center">
        <a
          href="https://status.catchagent.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-gray-400 hover:text-gray-600 transition-colors"
        >
          System status
        </a>
      </footer>
    </div>
  )
}
